module.exports = __webpack_public_path__ + "img/pheebok-sawasdee-ipa.a5bde7fa.png";